export enum LorenFeature {
  ADD_NOTES_TO_CHART = "ADD_NOTES_TO_CHART",
  CUSTOM_SHAFT_MONITORING_DASHBOARD = "CUSTOM_SHAFT_MONITORING_DASHBOARD",
  CUSTOM_SHAFT_MONITORING_EVENTS = "CUSTOM_SHAFT_MONITORING_EVENTS",
  DEVICE_REPORT = "DEVICE_REPORT",
  FMP100_CREATE_GEO_TAGGED_NOTIFICATIONS_FOR_ALL_USERS_ON_TRACKER_BUTTON_CLICKED = "FMP100_CREATE_GEO_TAGGED_NOTIFICATIONS_FOR_ALL_USERS_ON_TRACKER_BUTTON_CLICKED",
  GENERATE_PDF_REPORT = "GENERATE_PDF_REPORT",
  GENERIC_BATTERY_LEVEL_NOTIFICATIONS = "GENERIC_BATTERY_LEVEL_NOTIFICATIONS",
  GENERIC_CREATE_GEO_TAGGED_NOTIFICATIONS_FOR_ALL_USERS_ON_TRACKER_BUTTON_CLICKED = "GENERIC_CREATE_GEO_TAGGED_NOTIFICATIONS_FOR_ALL_USERS_ON_TRACKER_BUTTON_CLICKED",
  GENERIC_DASHBOARD = "GENERIC_DASHBOARD",
  GENERIC_MAP_GEOZONES = "GENERIC_MAP_GEOZONES",
  GENERIC_MAP_LAYERS_VISUALIZATION = "GENERIC_MAP_LAYERS_VISUALIZATION",
  GENERIC_RULES = "GENERIC_RULES",
  GENERIC_TRACES = "GENERIC_TRACES",
  GROUPS = "GROUPS",
  IMAGE_GALLERY = "IMAGE_GALLERY",
  LOREN_DEVICE_NOTIFICATION = "LOREN_DEVICE_NOTIFICATION",
  SMS_NOTIFICATION = "SMS_NOTIFICATION",
}
